export default {
  failed: 'FAILED',
  succeeded: 'SUCCEEDED',
};
